import React from 'react';
import PropTypes from 'prop-types';
import cuid from 'cuid';

import styles from './index.styl';

function InfoRow({ list }) {
  return (
    <div className={styles.rowWrapper}>
      {list.map(row => (
        <div className={styles.row} key={cuid()}>
          {row.map(({ title, subtitle }) => (
            <div className={styles.item} key={title}>
              <p className={styles.title}> {title}</p>
              <span className={styles.subtitle}>{subtitle}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

InfoRow.propTypes = {
  list: PropTypes.array,
};

export default InfoRow;



// WEBPACK FOOTER //
// ./src/components/UserInfoBlock/InfoRow.jsx